import type { Dispatch, Middleware, UnknownAction } from '@reduxjs/toolkit';

import { fetchActiveContractByCategory } from './actions';
import type { ContractCategory } from '../types';

const NOTIFICACAO_CONSUMPTION_ACTIONS = new Set([
  'extrajudicial/criarIndividual/fulfilled',
  'extrajudicial/criarLote/fulfilled',
  'extrajudicial/criarLoteComMapeamento/fulfilled',
]);

const NEGOCIACAO_CONSUMPTION_ACTIONS = new Set([
  'negociacaoIndividualWizard/createNegociacaoIndividual/fulfilled',
  'negociacoes/confirmLote/fulfilled',
]);

const ARBITRAGEM_CONSUMPTION_ACTIONS = new Set([
  'processoArbitral/submissaoStep/submitProcessoArbitral/fulfilled',
]);

const refetch = (dispatch: Dispatch<UnknownAction>, category: ContractCategory): void => {
  dispatch(fetchActiveContractByCategory(category) as unknown as UnknownAction);
};

export const contractsMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    typeof (action as { type: unknown }).type === 'string'
  ) {
    const type = (action as { type: string }).type;
    if (NOTIFICACAO_CONSUMPTION_ACTIONS.has(type)) {
      refetch(store.dispatch, 'NOTIFICACAO');
    } else if (NEGOCIACAO_CONSUMPTION_ACTIONS.has(type)) {
      refetch(store.dispatch, 'NEGOCIACAO');
    } else if (ARBITRAGEM_CONSUMPTION_ACTIONS.has(type)) {
      refetch(store.dispatch, 'ARBITRAGEM');
    }
  }

  return result;
};
